import React from "react";
import {useHistory} from "react-router-dom";
import {filtersSubject} from "../../hooks";

export function LinkBlock({url, title, icon, className}: any) {
    const history = useHistory();

    return (
        <li>
            <a href={url} className={url === (window.location.pathname).split('?')[0] ? 'selected' : ''}
               onClick={event => {
                   event.preventDefault();
                   filtersSubject.next({});
                   history.push(url);
               }}>
                <div className={'link-block ' + (className || '')}>{icon}</div>
                <span className={'link-title'}>{title}</span>
            </a>
        </li>
    )
}
